import { FileDecryptor } from '../UseCase/FileDecryptor';
import { OrderedByteChunker } from '../Chunker/OrderedByteChunker';
export async function readAndDecryptBackupFileUsingFileSystemAPI(fileHandle, file, fileSystem, crypto, onDecryptedBytes) {
    const decryptor = new FileDecryptor(file, crypto);
    const byteChunker = new OrderedByteChunker(file.encryptedChunkSizes, 'local', async (chunk) => {
        const decryptResult = decryptor.decryptBytes(chunk.data);
        if (!decryptResult) {
            return;
        }
        await onDecryptedBytes(decryptResult.decryptedBytes);
    });
    const readResult = await fileSystem.readFile(fileHandle, async (encryptedBytes) => {
        await byteChunker.addBytes(encryptedBytes);
    });
    return readResult;
}
